// File: src/components/LandingPage.jsx
import React from "react";

import HeroSection from "./landing/HeroSection";
import Features from "./landing/Features";


import Footer from "./landing/Footer";
import "./LandingPage.css";


export default function LandingPage() {
return (
<div className="lp-root">

<HeroSection />
<Features />


</div>
);
}

